export default "__VITE_ASSET__CJi6tvUG__"